
import {
  computed,
  defineComponent,
  onMounted,
  onUpdated,
  reactive,
  ref,
  Ref,
  watch,
} from "vue";
import FileUploader from "@/components/common/FileUploader";
import router from "@/router";
import { Form } from "vee-validate";
import Button from "primevue/button";
import { useI18n } from "vue-i18n";
import CustomConfirmDialog from "@/components/primevueCustom/ConfirmDialog.vue";
import { useConfirm } from "primevue/useconfirm";
import { IAlert } from "@/models/common";
import { useStore } from "vuex";
import { messageType } from "@/models/message";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import { RequestStatuses, RequestKindTypes } from "@/models/request";
import $API from "@/services";
import { IOnlineCarePurposeQuick, OnlineCareQuick } from "@/models/onlineCare";
import PageFrame from "@/components/common/PageFrame.vue";
import Sidebar from "primevue/sidebar";
import FileViewer from "@/components/file/FileViewer.vue";
import Textarea from "primevue/textarea";
import FileList from "@/components/file/FileList.vue";
import { IFileListItem } from "@/models/file";
import { DataType } from "@/services/file";
import RequestConfirm from "@/components/common/Confirm/RequestConfirm";

export default defineComponent({
  props: {
    isContent: {
      type: Boolean,
      default: true,
    },

    hospitalKey: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    const state = reactive({
      isLoading: true,
      id: "",
      requestStatus: null as RequestStatuses | null,
      purpose: {
        other: "",
        files: null as Array<IFileListItem> | null,
        pharmacyKey: null as Number | null,
      },
      selectFile: null as IFileListItem | null,
      visibleFull: false,
      isContent: props.isContent,
      selectedHospital: props.hospitalKey,
    });

    const store = useStore();

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const { t } = useI18n({ useScope: "global" });

    const formValidate = reactive({
      other: false,
    });

    const goBack = () => {
      router.go(-1);
    };

    const otherValidate = computed(() => formValidate.other);

    const isValidate = computed(() => {
      return otherValidate.value;
    });

    const confirm$: Ref<RequestConfirm | null> = ref(null);

    const saveConfirm = useConfirm();

    const saveConfirmDialog = async () => {
      saveConfirm.require({
        header: t("ReceptionSaveHeader"),
        acceptLabel: t("Yes"),
        rejectLabel: t("No"),
        group: "save",
        accept: async () => {
          await onSave();
        },
        reject: () => {},
      });
    };

    const fileUploader$: Ref<FileUploader | null> = ref(null);

    const requestKey = !state.id ? 0 : Number.parseInt(state.id.toString());

    watch(
      () => state.purpose,
      (n: IOnlineCarePurposeQuick) => {
        formValidate.other = !!n.other;
      },
      { deep: true }
    );

    const url = computed(() => {
      return `${$API.BaseURL}/api/ApiFileUploadV2/Upload?reftab=request&refkey=${state.id}`;
    });
    const filesCount = computed(() => {
      return state.purpose.files?.filter(
        (f) => f.PrescriptionFlag !== 1 && f.FileStatus === 0
      ).length;
    });

    const isEditable = computed(() => {
      return (
        !state.id ||
        ((state.requestStatus ?? 100) >= RequestStatuses.Preparing &&
          (state.requestStatus ?? 100) < RequestStatuses.Scheduled)
      );
    });
    const saveValidate = () => {
      return formValidate.other;
    };
    const onSave = async () => {
      try {
        store.commit(CommonMutationTypes.SET_IS_LODING, true);
        if (!saveValidate()) {
          alert.value = {
            content: "validateError",
            type: messageType.ERROR,
          };

          store.commit(CommonMutationTypes.SET_IS_LODING, false);
          return;
        }

        const saveData = new OnlineCareQuick({
          other: state.purpose.other,
          requestKey,
          hospitalKey: state.selectedHospital ?? null,
        });

        const req = await $API.RequestService.save(saveData);

        if (req) {
          state.id = req.RequestKey + '';
          state.requestStatus = req.RequestStatus;
          if (
            fileUploader$.value?.getFilesCount() &&
            fileUploader$.value.getFilesCount() > 0
          )
            await fileUploader$.value.upload(url);
          else {
            store.commit(CommonMutationTypes.SET_IS_LODING, false);
            confirm$.value?.isConfirmButton();
          }
        }
      } catch (e) {
        console.error(e);

        alert.value = {
          content: "저장 실패",
          type: messageType.ERROR,
        };
        console.log("a", !!alert.value.content);
      } finally {
        store.commit(CommonMutationTypes.SET_IS_LODING, false);
      }
    };

    const filesProgress = () => {
      if (!store.getters.getIsFileUpdate) {
        setTimeout(() => {
          // this.routerReplace();
          confirm$.value?.isConfirmButton();
        }, 1000);
      }
    };

    onUpdated(() => {
      if (state.isContent !== props.isContent)
        state.isContent = props.isContent;
    });

    onMounted(() => {
      state.isLoading = false;
    });

    return {
      t,
      saveConfirmDialog,
      state,
      alert,
      filesCount,
      isEditable,
      url,
      filesProgress,
      isValidate,
      RequestKindTypes,
      store,
      goBack,
      confirm$,
    };
  },
  methods: {
    async onSelectedRow(selectedItem: IFileListItem) {
      try {
        this.state.selectFile = selectedItem;
        if (this.state.selectFile.DataType === DataType.DICOM)
          await this.getStudyKeys(this.state.selectFile.FileKey.toString());

        this.state.visibleFull = true;
      } catch (e) {
        console.error(e);
      }
    },
    async getStudyKeys(fileKey: string) {
      return await $API.FileService.getStudyKeys(fileKey);
    },
    async deletedFile() {
      await this.onSetData();
    },

    async onSetData() {
      try {
        this.state.isLoading = true;
        this.store.commit(CommonMutationTypes.SET_IS_LODING, true);
        //this.state.purpose.pharmacyKey = -1;
      } catch (e) {
        this.store.commit(CommonMutationTypes.FILE_UPDATE, false);
        console.error(e);
      } finally {
        this.store.commit(
          CommonMutationTypes.SET_IS_LODING,
          this.store.getters.getIsFileUpdate
        );

        this.state.isLoading = false;
      }
    },
  },
  components: {
    Form,
    Button,
    CustomConfirmDialog,
    FileUploader,
    FileViewer,
    Sidebar,
    PageFrame,
    Textarea,
    FileList,
    RequestConfirm,
  },
});
